import { EventEmitter, Injectable } from '@angular/core';
import { ESidebarMode } from 'app/enums/sidebarmode.enum';
import { ICalendarEvent } from 'app/interfaces/event.interface';
import {
	AppointmentSidebarFrom,
	ISidebar,
} from 'app/interfaces/sidebar.interface';
import { DateTime } from 'luxon';

@Injectable({
	providedIn: 'root',
})

//utils shared between calendar components
export class CalendarUtilsService {
	public showEventsOfDay(date: Date, output): void {
		const sidebar: ISidebar = {
			date: date,
			id: null,
			mode: ESidebarMode.Appointments,
		};
		output.emit(sidebar);
	}

	public createEvent(luxonDate: DateTime, output): void {
		const sidebar: ISidebar = {
			date: luxonDate.toJSDate(),
			hour: luxonDate.toFormat('HH:mm'),
			id: null,
			mode: ESidebarMode.New,
			from: AppointmentSidebarFrom.CALENDAR,
		};
		output.emit(sidebar);
	}

	public openDetailsModal(
		id: string,
		type: 'event' | 'busyslot',
		output: EventEmitter<ISidebar>,
		event?: ICalendarEvent
	): void {
		const sidebar: ISidebar = {
			date: new Date(),
			id: id,
			type,
			mode: this.getSidebarModeFromEvent(event, type),
		};
		output.emit(sidebar);
	}

	public getSidebarModeFromEvent(
		event: ICalendarEvent,
		type: 'event' | 'busyslot'
	): ESidebarMode {
		if (!event) {
			return ESidebarMode.Details;
		}

		if (type === 'busyslot') {
			return ESidebarMode.Details;
		}

		return ESidebarMode.AppointmentDetails;
	}

	public scrollToHour() {
		setTimeout(() => {
			const scrollContainer =
				document.getElementsByClassName('line-hour-circle')[0];
			if (scrollContainer) {
				scrollContainer.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			}
		}, 1500);
	}
}
